import TagManager from "react-gtm-module";
import type { addItem } from "../actions/item/add";
import type { removeItem } from "../actions/item/remove";
import { getCartItemsData } from "./dataLayerData";

type RemoveCartItemType = NonNullable<NonNullable<Awaited<ReturnType<typeof removeItem>>>["data"]>;
type AddProductToCartType = NonNullable<NonNullable<Awaited<ReturnType<typeof addItem>>>["data"]>;

export function dataLayerRemoveFromCart(item: RemoveCartItemType["item"]) {
	TagManager.dataLayer({ dataLayer: { ecommerce: null } });
	TagManager.dataLayer({
		dataLayer: {
			event: "removeFromCart",
			ecommerce: {
				remove: {
					products: [getCartItemsData(item)],
				},
			},
		},
	});
	TagManager.dataLayer({
		dataLayer: {
			event: "remove_from_cart_ga4",
			ecommerce: {
				items: [getCartItemsData(item, true)],
			},
		},
	});
}

export function datalayerAddToCart(item: AddProductToCartType["item"]) {
	TagManager.dataLayer({ dataLayer: { ecommerce: null } });
	TagManager.dataLayer({
		dataLayer: {
			event: "addToCart",
			ecommerce: {
				currencyCode: item.totals.rowTotal.currency,
				add: {
					products: [getCartItemsData(item)],
				},
			},
		},
	});
	TagManager.dataLayer({
		dataLayer: {
			event: "add_to_cart_ga4",
			ecommerce: {
				items: [getCartItemsData(item, true)],
			},
		},
	});
}
